import { render, staticRenderFns } from "./groupUsers.vue?vue&type=template&id=0196d47a&scoped=true&"
import script from "./groupUsers.vue?vue&type=script&lang=js&"
export * from "./groupUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0196d47a",
  null
  
)

export default component.exports